<style>
  #dialog_container {
    box-sizing: border-box;
    width: min(520px, calc(100vw - 32px));
    max-height: calc(100dvh - 32px);
    overflow: auto;
    padding: var(--tl4k-spacing-xl);
    border: 1px solid var(--tl4k-outline-variant);
    border-radius: var(--tl4k-border-radius-lg);
    background: var(--tl4k-surface-default);
    color: var(--tl4k-neutral-800);
    font-family: var(--tl4k-font-family-body);
    font-size: var(--tl4k-font-size-small);
    line-height: 1.5;
  }

  #ii_tabs, #dialog_buttons {
    display: flex;
    flex-wrap: wrap;
    gap: var(--tl4k-spacing-sm);
  }

  #ii_tabs { border-bottom: 1px solid var(--tl4k-outline-variant); padding-bottom: var(--tl4k-spacing-md); }
  #ii_tabs button { flex: 1; }
  #dialog_buttons { justify-content: flex-end; margin-top: var(--tl4k-spacing-xl); }
  .ii-page { display: none; }
  .ii-page-active { display: block; }
  #ii_url_note { color: var(--tl4k-neutral-600); }

  button, input {
    box-sizing: border-box;
    max-width: 100%;
    font: inherit;
    color: inherit;
  }

  button, input[type="url"] {
    min-height: 44px;
    padding: var(--tl4k-spacing-sm) var(--tl4k-spacing-md);
    border: 1px solid var(--tl4k-outline);
    border-radius: var(--tl4k-border-radius-md);
    background: var(--tl4k-surface-default);
  }

  button { cursor: pointer; }
  button:hover { background: var(--tl4k-surface-neutral); }
  button.ii-active { background: var(--tl4k-primary-50); border-color: var(--tl4k-primary-500); color: var(--tl4k-primary-700); }
  #ii_ok { background: var(--tl4k-primary-500); color: var(--tl4k-surface-default); border-color: var(--tl4k-primary-500); }
  #ii_ok:hover { background: var(--tl4k-primary-700); }
  :is(button, input):focus-visible { outline: 2px solid var(--tl4k-focus); outline-offset: 2px; }
  input[type="url"] { width: 100%; }
  #ii_paste_preview img { display: block; max-width: 100%; max-height: 240px; margin: auto; object-fit: contain; }
</style>
<elix-dialog id="insert_image_box" aria-label="insert image" closed>
  <div class="overlay"></div>
  <div id="dialog_container">
    <div id="dialog_content">
      <div id="ii_tabs" role="tablist">
        <button type="button" class="ii-tab ii-active" data-tab="file" id="ii_tab_file" role="tab"></button>
        <button type="button" class="ii-tab" data-tab="paste" id="ii_tab_paste" role="tab"></button>
        <button type="button" class="ii-tab" data-tab="url" id="ii_tab_url" role="tab"></button>
      </div>
      <div class="ii-page ii-page-active" id="ii_page_file">
        <p id="ii_file_hint"></p>
        <input type="file" id="ii_file_input" accept="image/*" multiple>
      </div>
      <div class="ii-page" id="ii_page_paste">
        <p id="ii_paste_hint"></p>
        <div id="ii_paste_preview"></div>
      </div>
      <div class="ii-page" id="ii_page_url">
        <p id="ii_url_hint"></p>
        <input type="url" id="ii_url_input" placeholder="https://example.com/image.png">
        <p id="ii_url_note"></p>
      </div>
    </div>
    <div id="dialog_buttons">
      <button id="ii_ok"></button>
      <button id="ii_cancel"></button>
    </div>
  </div>
</elix-dialog>
